module.exports = __webpack_public_path__ + "static/media/tutorial.2ba1a234.mp3";